import { render } from "./Dccs.vue?vue&type=template&id=90e67c36&scoped=true"
import script from "./Dccs.vue?vue&type=script&lang=js"
export * from "./Dccs.vue?vue&type=script&lang=js"

import "./Dccs.vue?vue&type=style&index=0&id=90e67c36&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90e67c36"],['__file',"src/views/Dccs/Dccs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "90e67c36"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('90e67c36', __exports__)) {
    api.reload('90e67c36', __exports__)
  }
  
  module.hot.accept("./Dccs.vue?vue&type=template&id=90e67c36&scoped=true", () => {
    api.rerender('90e67c36', render)
  })

}


export default __exports__